import BarChartIcon from '@mui/icons-material/BarChart';
import { Divider, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import TextFieldComponent from '@components/inputs/textField/TextField.component';
import { Sizes } from '@constants/sizes.constants';
import { CreateAuditInformation } from '@store/audits/audits-information/audits-information.model';

interface PreAuditProps {
  updateAuditInformation: (
    field: keyof CreateAuditInformation, value: any
  ) => void;
  auditInformation?: CreateAuditInformation;
  errors: any;
}
const PreAuditData = (props: PreAuditProps) => {
  const { auditInformation, updateAuditInformation, errors } = props;
  const { t } = useTranslation();
  const numberRegex = /^(?:\d+|undefined)?$/;

  return (
    <>
      <Stack py="24px" pr="10px">
        <Stack direction="row" mt="3px" alignItems="center" spacing={0.5}>
          <BarChartIcon sx={{ backgroundColor: '#E55142', borderRadius: '2px', width: '25px', color: 'white' }} />
          <Typography fontSize={24} fontWeight="700">
            {t('audits.preAudit.types.data')}
          </Typography>
        </Stack>
        <Stack py="24px" pr="10px" spacing={1.5}>
          {/* <SelectComponent
            color="primary"
            labelWidth={Sizes.drawerInputLabelWidth}
            label={t('audits.preAudit.data.legend')}
            placeholder={t('audits.preAudit.data.legend')}
            handleChange={(legend) => updateAuditInformation('data', { legend })}
            items={Data.selectItems()}//TODO: A définir
            value={auditInformation?.data?.legend ?? ''}
          /> */}
          <TextFieldComponent
            color="primary"
            labelWidth={Sizes.drawerInputLabelWidth}
            label={t('audits.preAudit.data.legend')}
            placeholder={t('audits.preAudit.data.legend')}
            handleChange={(legend) => updateAuditInformation('data', { legend })}
            value={auditInformation?.data?.legend || ''}
            error={errors.legend}
            required={true}
          />
          <TextFieldComponent
            color="primary"
            labelWidth={Sizes.drawerInputLabelWidth}
            label={t('audits.preAudit.data.data')}
            placeholder={t('audits.preAudit.data.data')}
            handleChange={(description) => numberRegex.test(description) ? updateAuditInformation('data', { description }) : null}
            value={auditInformation?.data?.description ?? ''}
            error={errors.description}
            required={true}
          />
          <TextFieldComponent
            color="primary"
            labelWidth={Sizes.drawerInputLabelWidth}
            label={t('audits.preAudit.data.unit')}
            placeholder={t('audits.preAudit.data.unit')}
            handleChange={(unit) => updateAuditInformation('data', { unit })}
            value={auditInformation?.data?.unit ?? ''}
          />
          <Divider variant="fullWidth" orientation="horizontal" />
        </Stack>
      </Stack>
    </>
  );
};

export default PreAuditData;
